 
import React, {useEffect, useState} from 'react'  
import { BrowserRouter as Router, Routes, Route, HashRouter } from 'react-router-dom'; 
import PrivateRoute from './utils/PrivateRoute'
import { AuthProvider } from './context/AuthContext' 
import { OrderProvider } from "./context/OrderContext";
import { CreditMemoProvider } from './context/CreditMemoContext';
import { ReturnsProvider } from './context/ReturnsContext';
import OrdersPage from "./pages/dashboard/orders/orders"
import LoginPage from "./pages/auth/login";
import ResetPage from './pages/auth/resetpassword';
import ChangePass from './pages/auth/changePass'
import { QueryClient, QueryClientProvider } from "react-query";
import Support from './pages/dashboard/support/support';
import CreditMemo from './pages/dashboard/credit-memo/creditMemo'
import Returns from './pages/dashboard/returns/returns'
import NotFound from './pages/error/NotFound';
import Loader from './components/Loader/Loader';
import { useTranslation } from 'react-i18next';

const queryClient = new QueryClient();


function App() { 
  const [t, i18n] = useTranslation('common'); 
  const [showLoader , setShowLoader] = useState(true)
  useEffect(()=>{   
    if(!localStorage.getItem("appLang")){ 
      localStorage.setItem('appLang', 'de'); 
      setShowLoader(false)
    }else{  
      i18n.changeLanguage(localStorage.getItem("appLang")) 
      setShowLoader(false)
    } 
  },[showLoader])
  return (
    <> 
    {showLoader  ? 
    <Loader/> :
    <> 
      <div className="App">
        <HashRouter> 
        <AuthProvider>
        <QueryClientProvider client={queryClient}> 
          <Routes> 
            <Route path="/login" element={<LoginPage />} />
            <Route path="/reset-password" element={<ResetPage />} />
            <Route path="/change-password" element={<ChangePass />} />
            <Route exact path='/' element={<PrivateRoute/>}>
              <Route path="/" exact element={
                <OrderProvider>
                    <OrdersPage/>
                </OrderProvider> 
              } /> 
            </Route>

            <Route exact path='/credit-memo' element={<PrivateRoute/>}>
              <Route path="/credit-memo" exact element={
                <CreditMemoProvider>
                    <CreditMemo/>
                </CreditMemoProvider> 
              } /> 
            </Route> 
            
            <Route exact path='/returns' element={<PrivateRoute/>}> 
              <Route path="/returns" exact element={ 
                <ReturnsProvider>
                    <Returns/>
                </ReturnsProvider> 
              } /> 
            </Route>

            <Route exact path='/support' element={<PrivateRoute/>}>
              <Route path="/support" exact element={ <Support/>} /> 
            </Route>
            <Route path="*" element={<NotFound/>}/>
          
          </Routes>  
          </QueryClientProvider>
        </AuthProvider>
    
      </HashRouter> 
      </div>
    </> }
    </> 
  );
}

export default App;
